import { GetCustomerTagsResult } from '../user-domain.types';

export const createCustomerTagData = {
  id: 'f82a5537-b44b-4160-88f4-496ee2a08d93',
  clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
  key: 'TEST TAG',
  tagType: 'CUSTOM',
  category: 'CUSTOM',
  categoryDisplayTitle: 'Custom',
  categoryDisplayRank: 3,
  title: 'Test tag',
  description: 'Test tag description',
  attributeType: 'NUMBER',
  collectionValues: [],
  source: 'IMPORTED_MANUAL',
  sourceDisplayTitle: 'Imported / Manual',
  tagRank: null,
  visibility: [
    'segment.targeting',
    'message.auto.targeting',
    'message.activity.targeting',
    'offer.auto.targeting',
    'offer.activity.targeting',
    'offer.redemption',
    'loyalty.auto.targeting',
    'loyalty.activity.targeting',
    'loyalty.redemption',
  ],
};

export const getCustomerTags: GetCustomerTagsResult = {
  tagAndRuleDTOS: [
    {
      id: '555d860a-e001-4902-aef5-8f4ca51d1d64',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '0023',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '0023',
      description: '32',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b4e878cb-6898-4dea-8cc7-c89790ddcb91',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '00DATA',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '00data',
      description: '00data',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'aed0cc40-b82c-4de7-ac39-084a102ea691',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '00_EW',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '00_ew',
      description: 'ew',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a229067b-73e1-4fab-b6da-e67aaca774d8',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '14012023_TESTTAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '14012023_TestTag',
      description: 'Testing story/185384',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'cc9e15c4-f6eb-40af-8d6a-7a3956ad5d4d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '1998_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '1998_Tag',
      description: '1998_Tag',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'c6d2dd9e-ecb7-4f64-bf15-37c3a31670cf',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '3213ASD',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '2232_13ASD',
      description: 'sds',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '2a99bf2e-6af0-41d4-a25f-597a62c38067',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '23',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '23',
      description: '32',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a5292c91-61eb-40d1-8c61-eb986a9d5524',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '24012023_TESTTAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '24012023_TestTag',
      description: '24012023_TestTag',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '421df22c-059e-4d56-99d1-d3ee1dc1e9b3',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '25012023AUTOMESSAGE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '25012023Automessage',
      description: '25012023Automessage',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b7793a3f-24c4-4582-8fc7-52b7d34e20e7',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '67AV',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '88_67AV',
      description: '67AV',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '3a9b35cc-6ee8-4d39-b6d4-83a196c3df3c',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: '98ASV',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: '98ASV',
      description: '98ASV',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f6d4f79b-6d10-4477-b3a2-d50388dff1e4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'ABCD',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'abcd',
      description: 'simple',
      attributeType: 'COLLECTION',
      collectionValues: ['True'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d897f05-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'AGE',
      tagType: 'SYSTEM',
      category: 'DEMOGRAPHICS',
      categoryDisplayTitle: 'Demographics',
      categoryDisplayRank: 0,
      title: 'Age',
      description: 'A guest’s age. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 3,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '2e1c2588-699a-4d88-9868-0937fac5541f',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'ALLERGIES',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'ALLERGIES',
      description: 'ALLERGIES',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '71dce7aa-093b-461d-a9d0-b7a5b83f79ff',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'ANTHONY_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Anthony Tag',
      description: "Anthony's test TAG",
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a6257cce-99e7-42fd-a588-304d6d1244c3',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'IMD',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'asdasd',
      description: 'Imported Manual Date',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b0417d4f-741c-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'ATTRITION_RISK',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Attrition Risk',
      description: 'Customer churn status. Ex: CHURNED, SLIDER.',
      attributeType: 'COLLECTION',
      collectionValues: ['CHURNED', 'SLIDER', 'NO_RISK'],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a0022c2c-99a4-420f-8ee2-3cbc55a0fad2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'AVB_AD_AV_AD',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'AVB   AD   AV              AD',
      description: 'AVB   AD   AV              AD',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f8c347ed-9030-452d-a79c-c6b3232bed33',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'AVD_5DS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'AVd 5ds',
      description: 'AVd  5ds',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898135-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'AVERAGE_BASKET_VALUE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Average Basket Value',
      description: 'This is your guests’ average order size. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 1,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8981bc-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'QUANTILE_AVERAGE_BASKET_VALUE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Average Basket Value (Percentile)',
      description:
        'This is how the average basket value for this guest compares to all other guests. For example, a value of 99 means that this guest is in the top 1% of your guests. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 2,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d89829a-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'AVERAGE_BASKET_VALUE_PER_MONTH',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Average Monthly Spend',
      description:
        'This is the average amount your guest spends every 30 days. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 4,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8982f8-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'PURCHASES_PER_MONTH',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Average Orders per Month',
      description:
        'This is the average number of orders placed by the guest every 30 days. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 5,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d89840c-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'AVERAGE_PURCHASES_PER_WEEK',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Average Orders Per Week',
      description:
        'This is the average number of orders your guest places every 7 days. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 8,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d89822f-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'AVERAGE_WEEKLY_SPEND',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Average Weekly Spend',
      description:
        'This is the average amount your guest spends every 7 days. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 3,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b0417bc7-741c-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'BASKET_SUBTOTAL',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Basket Subtotal',
      description: '< Need to fill this >',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: null,
      visibility: ['offer.redemption', 'loyalty.redemption'],
    },
    {
      id: 'b0417801-741c-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'BASKET_TOTAL',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Basket Value',
      description:
        'Target guests that spend a certain amount on this order. They will receive the Communication after they place their order. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: null,
      visibility: [
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '8b1a617d-6408-4195-9132-7c68b1476462',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'BIRTH_MONTH',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'BIRTH_MONTH',
      description: 'BIRTH_MONTH',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'd32b402e-1df6-4842-9715-22f10aa0e319',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'BOOTAPP',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'BOOTAPP',
      description: 'BOOTAPP',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898af3-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'CATEGORY_CHECK_IN',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Category Check In',
      description:
        'Use this to target guests that check in via a QR code or Bluetooth Beacon.',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 8,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '0edcd12c-f60d-4d1f-b2ba-bd0c3dabcc74',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'CUS_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'cus tag',
      description: 'customer tag',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '504586e7-f0ac-4473-acbf-967df060c174',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'CUS_TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'CUS TEST',
      description: 'CUS TEST',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e2d3856d-81bf-4cb9-ae71-35f0021eba6e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'CUSTOMER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'CUSTOMER',
      description: 'CUSTOMER',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '7a76aafd-94bf-4023-b741-9fa27cdaf2b0',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'CUSTOMER_TAGS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Customer tags',
      description: 'Customer tags on the customer screen',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f403b88e-babc-42ab-8434-33840641b1bf',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'CUSTOMER_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'customer_tag',
      description: 'cus',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'bd0d993d-806c-4e62-b2ba-99a45d836dab',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'CUS_12',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'cus_12',
      description: 'cus',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '6dccbf87-1a84-4dc7-b2b1-c2aec64ba8dd',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'DARREL_TEST_TAG_2',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Darrel Test TAG 2',
      description: 'New Tag',
      attributeType: 'COLLECTION',
      collectionValues: ['Dar_PAR'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e2e2f198-17c0-412b-b89a-16ef47454408',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'DARREL_TEST_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Darrel Test Tag11112222',
      description: 'New Test Tag',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '34c14653-4dec-4ce5-98ea-efafd1a9f3ed',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'DATE_CUSTOMER_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Date Customer Tag',
      description: 'date tag',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898872-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'DAY_OF_WEEK',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Day Of Week',
      description: 'The day of the week. ',
      attributeType: 'COLLECTION',
      collectionValues: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 3,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8984d3-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'DAYS_SINCE_LAST_PURCHASE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Days since Last Purchase',
      description: 'The number of days since a guest last placed an order. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 10,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898544-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'QUANTILE_DAYS_SINCE_LAST_PURCHASE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Days since Last Purchase (percentile)',
      description:
        'This is how many days since last purchase for a guest compares to all other guests. For example, the 0-1 percentile means that 99% of guests have purchased more recently than them. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 11,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a815a47b-f53c-4892-b183-71fac7d06aab',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'DSD_SDS_DS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'dsd___________sds   ds',
      description: '232',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '161a1957-422a-4893-9c6c-9e0673c9bba9',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'DT',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'DT',
      description: 'DT',
      attributeType: 'COLLECTION',
      collectionValues: ['True'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '2156942f-a8c2-4bc1-b0d7-7449925ce19a',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'DTB',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'DTB',
      description: 'DTB',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'fcc4de0f-299c-449e-aaf7-6b9e199cfc62',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'EDIT_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Edit Tag',
      description: 'Edit Tag',
      attributeType: 'TEXT',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '523a87c0-a9a6-4c07-88d1-afe5e3b8f857',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'EEMS_TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'EEMS_TEST',
      description: 'ems test',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '838c4940-e487-4c08-8dd9-ec8d44239a08',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'EMAIL_TESTER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Email Tester11111',
      description: 'Email Tester',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '95951012-880d-4187-8746-eedb2b4e6ba7',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'ERT_S3',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'ERT_S3',
      description: 'ERT_S3',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d897c23-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'EVERYONE',
      tagType: 'SYSTEM',
      category: 'DEMOGRAPHICS',
      categoryDisplayTitle: 'Demographics',
      categoryDisplayRank: 0,
      title: 'Everyone',
      description: 'All of your guests. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 2,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e62e0539-5561-4ece-ba71-cfe6b5ad60f1',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'EXP',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'EXP',
      description: 'EXP',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d897ff0-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'GENDER',
      tagType: 'SYSTEM',
      category: 'DEMOGRAPHICS',
      categoryDisplayTitle: 'Demographics',
      categoryDisplayRank: 0,
      title: 'Gender',
      description: 'Males or Females.',
      attributeType: 'COLLECTION',
      collectionValues: ['Male', 'Female'],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 4,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a6751ae3-492a-4aac-a1e9-abab9bc60344',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'GENERATED',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Generated',
      description: 'Generated',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898098-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'GEO',
      tagType: 'SYSTEM',
      category: 'DEMOGRAPHICS',
      categoryDisplayTitle: 'Demographics',
      categoryDisplayRank: 0,
      title: 'Geo Location',
      description:
        'Guests who are currently within a given number of miles of a geographical location. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 5,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '0e89acfa-75a9-45f6-aef3-2f94725a9194',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'GH__JH',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'gh_ jh',
      description: '89',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e54b8efc-2426-4075-a319-2daa6926801d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'GID',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'GID',
      description: 'Guest Input Date',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898683-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'GIFTCARD_ADD_VALUE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Gift Card - Add Value',
      description: 'Guests that added value to a gift card.',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 14,
      visibility: [
        'message.activity.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898619-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'GIFTCARD_PURCHASE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Gift Card - Purchase Value',
      description: 'Guest that purchased a gift card of a certain value. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 13,
      visibility: [
        'message.activity.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'c9baaeb0-709e-43b9-b86e-10144c75c190',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'GIN',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'GIN',
      description: 'Guest Input Number',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'd0efa255-f001-459e-9fd0-2df917aa8004',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'GIP',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'GIP',
      description: 'Guest Input Pick List',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '3b93b917-b3cf-4851-8708-42fb363a27e2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'GIT',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'GIT',
      description: 'Guest Input Text',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '16972ce8-00e9-42bf-b78d-3571c2329be7',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'HOTFIX',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'HOTFIX',
      description: 'HOTFIX',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '010a5432-66a6-44f4-aa91-99b0a75afa44',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'HYPEED_____TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'hypeed     test',
      description: 'hypeed     test',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '67323539-24d8-4dbe-8195-07d9bfd4efa6',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'IMN',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'IMN',
      description: 'Imported Manual Number',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a57eaca0-10bd-481e-bfb9-232a181c0f93',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'IMP',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'IMP',
      description: 'Imported Manual Pick List',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '9da52d21-5c9c-4048-9a58-6da5552580d2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'IMPORTED_RUSH_PICKLIST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'IMPORTED_RUSH_picklist',
      description: 'test - rush 3',
      attributeType: 'COLLECTION',
      collectionValues: ['Bread', 'Cookies', 'salad'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '1552f81c-5794-43eb-b45f-e92fc229acb2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'IMT',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'IMT',
      description: 'Imported Manual Text',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b7500fc7-604b-4feb-afc3-207d8aabd2d4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'IS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'IS',
      description: 'IS',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898af4-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'ITEM_CHECK_IN',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Item Check In',
      description: 'Guests that check in by scanning an item specific QR Code.',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 8,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '0acb9164-e096-496d-bfea-4da979173df6',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'ITEM_SELECT',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'ITEM SELECT',
      description: 'ITEM SELECT',
      attributeType: 'COLLECTION',
      collectionValues: ['ITEM1', 'ITEM2'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e490bb0c-e1df-464c-85bd-cd4130ae0697',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'JANAKA_KUAMARA_YY',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'janaka kuamara yy',
      description: 'ds',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '00ddd4ac-e11b-47e4-8a9e-03fe82b63e80',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'JANAKA_KUMARA',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'janaka_kumara',
      description: 'rsdsd',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '02fa0c68-38a3-45a9-ae65-6078e1105589',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'JANAKA_KUMARA_SF',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'janaka_kumara_sf',
      description: 'jk',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'dd2c1651-7a37-47a0-9931-850747053c3f',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'JH_JK_KJK_JKJ',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'jh_jk_kjk_jkj',
      description: '32',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '2e2761da-a7f8-49d3-a73c-c2c640831fe3',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'JKJKJ_JJEWWWEWEWEWEEEWEWEWE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'jkjkj          jjewwweweweweeewewewe',
      description: 'dw',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b041ceaa-741c-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'JOURNEY_STAGE',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Journey Stage',
      description: 'Customer Journey',
      attributeType: 'COLLECTION',
      collectionValues: [
        'ROOKIE',
        'REGULAR',
        'LOYALIST',
        'CHAMPION',
        'WHALE',
        'CHURNED',
      ],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'aa55a87f-39d0-4a58-8eab-50e7034ab768',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'KT1',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'KT1',
      description: 'KT1',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '4be77869-f39f-4349-997b-275df04d58cc',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'KT2',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'KT2',
      description: 'KT2',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '8e4f7502-93ab-4a10-8c8c-3701d9c73d88',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'KT3',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'KT3',
      description: 'KT3',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'c3055c76-f29b-43e8-9294-8556c9273573',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'KUMARA_K',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'kumara     k',
      description: 'njj',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8985ad-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'LAST_PURCHAS_ON',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Last Order Date',
      description: 'This is when the guest last completed an order. ',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 12,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '942d79f3-e025-4067-a311-ef25f265243d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'LAST_PURCHASE_ON',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'LAST_PURCHASE_ON',
      description: 'LAST_PURCHASE_ON',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898472-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'NO_OF_TRANSACTIONS',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Lifetime Orders',
      description:
        'The total number of orders a guest has placed in their lifetime. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 9,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '7a3102b2-8b18-11ec-a487-0a20624d3e8f',
      clientId: '*',
      key: 'DAYS_SINCE_SIGNUP',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Days since Signup',
      description:
        'The number of days that have elapsed since the customer signed up',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 15,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8989be-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'REFERRAL',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Lifetime Referrals',
      description: 'The total number of people a guest has referred. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 6,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8983ad-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'BASKET_VALUE_TOTAL',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Lifetime Spend',
      description:
        'This is total amount this guest has spent since they signed up. ',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 7,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d89875b-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'POINTS',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Loyalty Points',
      description: 'Guest’s current loyalty balance.',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 1,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8988e3-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'MESSAGE_SHARE',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Message Share',
      description: 'Guests that share a Message on Facebook or Twitter. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 4,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '93a13dc9-1763-460a-8889-5af76ad651d9',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'MMS_D5',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'MMS D5',
      description: 'MMS D5',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '8afb9d4c-0ee1-4868-b498-c0ac644a4d09',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'MMS_TES',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'MMS_tes',
      description: 'MMS_tes',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '26081fe5-6511-46ce-872b-f267b52b6919',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'MSG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'MSG',
      description: 'MSG',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '11832b86-8006-4f5d-8824-6620a1489c72',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'NEW_TAG_TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'New Custom Tag Test',
      description: 'New Tag Test',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '3f0398ec-5b9f-4348-bc88-8d2093f2fc08',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'NEW_TITLE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'New Title',
      description: 'Number new tag',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8817ae-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'NO_ONE',
      tagType: 'SYSTEM',
      category: 'DEMOGRAPHICS',
      categoryDisplayTitle: 'Demographics',
      categoryDisplayRank: 0,
      title: 'No One (Draft Mode)',
      description:
        'Use this to create a Communication that will not be distributed to any guests. You would use this to create a draft. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 1,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e1c7ffe0-3189-41a8-87f9-27b834b005bd',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'ONLY_THIS_USER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'ONLY THIS USER',
      description: 'ONLY THIS USER',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b0417c68-741c-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'ORDER_OPTION_TYPE',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Order Option Type',
      description: '< Need to fill this >',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: null,
      visibility: ['offer.redemption', 'loyalty.redemption'],
    },
    {
      id: 'b0417ce0-741c-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'ORDER_TYPE',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Order Type',
      description: 'Type of the order. Ex: Pickup, Delivery.',
      attributeType: 'COLLECTION',
      collectionValues: ['Delivery', 'Pickup'],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: null,
      visibility: ['offer.redemption', 'loyalty.redemption'],
    },
    {
      id: 'a44b6482-e283-4aa5-8a0d-4df881780870',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'PETE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'PETE',
      description: 'PETE',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'c12d7b69-113d-4770-8ad7-5867b5aa27f9',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'PICK_LIST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'PICK LIST',
      description: 'PICK LIST',
      attributeType: 'COLLECTION',
      collectionValues: ['1', '2', '3', '4'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b626fbab-0eee-49ae-a8ef-04b61c1139d9',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'PICK_LIST_CUSTOMER_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Pick List Customer Tag',
      description: 'Pick list',
      attributeType: 'COLLECTION',
      collectionValues: ['Item 1', 'Item 2', 'Item 3'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '530e5341-505c-4868-848b-6119fad7b1d8',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'PIZZA_LOVER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Pizza Lover Loyalty',
      description: 'Pizza Lover',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '9f29236a-2ec7-4344-8497-45c6ecda4398',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'POSTA2_CODE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'POSTA2 CODE',
      description: 'POSTA2 CODE',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5901b3e7-e0d9-405f-a17d-1e1c796b54ae',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'POSTAL_CODE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'POSTAL CODE',
      description: 'POSTAL_CODE',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898af5-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'PROMO_CODE',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Promo Code',
      description: 'Use this to target guests that enter a Promo Code.',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 8,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: 'cbe6ff88-e042-4772-8a8b-c897b0b1c7ec',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'PUSHTEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'PUSHTEST',
      description: 'PUSHTEST',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'abbb1bb8-a0b2-4380-8840-fc109f938064',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'QA_P',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'QA P',
      description: 'QA P',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e172ddad-7a3b-4562-abe2-01f3d4678fd4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'QU',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'QU',
      description: 'QU',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '42364896-889e-4ebe-9428-c84b4e72803d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'RAT',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'RAT',
      description: 'RAT',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898950-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'REFERRAL_SIGNUP',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Referral Signup',
      description: 'Any guest who signs up using a valid referral code. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 5,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5530d83e-d6bb-41e9-a0c4-f5e8481efeca',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'REG',
      description: 'REG',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5a84b13a-0fe3-47ec-92ff-d2b995507032',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REG_22',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'REG 22',
      description: 'REG 22',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'dc36f93d-8b1d-4f9a-903f-0803493126b5',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REG_33',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'REG 33',
      description: 'REG 33',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f560467c-f7a1-4bcd-9fbb-b2f927e04c65',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REG_TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'REG Test',
      description: 'REG Test',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '390fa2b7-82ef-4f55-ac01-a5ae07d3013e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REGRESSION',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'REGRESSION',
      description: 'REGRESSION',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '864a4ee4-a538-48d9-af8f-b4c6d710a32b',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REGRESSION2',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'REGRESSION2',
      description: 'REGRESSION2',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '18cfa67e-3af6-4630-a392-a25db3c1ad12',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'REVERT_AUTO_TAGGER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Revert Auto Tagger',
      description: 'Revert Auto Tagger',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'df53bb3a-902b-46a0-aa02-2aa4f5ab8349',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'RUSH_TEST_GUEST_INPUT_TO_BE_DELETED',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'rush test guest input to be deleted updated',
      description: 'this is a test - update',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '85598baa-4fa2-4d93-b187-2b8b5f465600',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SAMPLE_SEGEMENT',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Sample Segement',
      description: 'Sample Segement',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'c9ec7284-90dd-4ea4-8229-3af6b353d7e0',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SDS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'sds',
      description: 'sds',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b24b112d-e122-477d-8b71-026cbbdd04c9',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SDS_SD_SD',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'sds sd sd',
      description: 'ds',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'c50cb928-ec31-4309-8058-c106bbeb116e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SEGMENT_TEST_TAG111',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Segment',
      description: 'Segment Test Tag1111',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '79b140dc-d2f6-4ca0-81b9-fc0581fae8e2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SEGMENT_TEST_TAG1111',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Segment Test Tag1111',
      description: 'Segment Test Tag1111',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '17f65722-3d89-4085-983e-f34b44c8a8a0',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SEGMENT_TEST_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Segment Test Tag11111',
      description: 'Segment Test Tag1111',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d89880f-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'SIGNUP',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Signup',
      description:
        'Guests that have created an account through the app or web. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 2,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '88f99392-f4d9-4565-8f9e-a55c2466dc40',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SIGNUP_TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SIGNUP_TEST',
      description: 'SIGNUP_TEST',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '0a64bba9-03cf-4140-8269-578beec2d959',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_______TESTER3',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS       Tester3',
      description: 'SMS       Tester3',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '35b8ea22-e1c2-4830-8073-1173dd6fab52',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS______TESTER5',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS      Tester5',
      description: 'SMS      Tester5',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f5f65684-b4b0-4533-9e29-3d2a37da41e2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS____TESTTER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS    Testter',
      description: 'SMS    Testter',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '014fb2cf-effb-4b6e-9ab2-1da0080206bc',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_ADD_PLUS_M',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'sms add plus m',
      description: 'sd',
      attributeType: 'DATE',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '346a067b-7aa8-4936-9c56-e62b1e2cc866',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_K_K_KL_K',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS k k kl k',
      description: 'fd',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f36cac97-f43c-4853-ab5c-1e3c5f742a0b',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_T4J_J',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS T4J J',
      description: 'test',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'aa5dea48-4d3e-4c3b-a658-d626a6450c26',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_TESTER',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS Tester',
      description: 'SMS Tester',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e73df7d6-6f56-48bc-8fce-a932f91131bf',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_TESTER1',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS Tester1',
      description: 'SMS Tester1',
      attributeType: 'COLLECTION',
      collectionValues: ['SMS Tester'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '2502ca93-68ae-4278-b549-7c043d9efe36',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_TESTER2',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS Tester2',
      description: 'SMS Tester2',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '2c06176e-0c9c-4815-a345-6a5c50a8b5c8',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'SMS_TESTER_1',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'SMS_TESTER_1',
      description: 'dss',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898af6-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'STORE_CHECK_IN',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Store Check In',
      description:
        'Use this to target guests that check in at a certain Store via a QR code or Bluetooth Beacon.',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 8,
      visibility: [
        'segment.targeting',
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: '5d898a8f-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'SURVEY_COMPLETE',
      tagType: 'SYSTEM',
      category: 'OTHER',
      categoryDisplayTitle: 'Other',
      categoryDisplayRank: 2,
      title: 'Survey Complete',
      description: 'Guest that completed a Survey. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 7,
      visibility: [
        'message.activity.targeting',
        'offer.activity.targeting',
        'loyalty.activity.targeting',
      ],
    },
    {
      id: 'fbb80c9b-e3df-4adc-b36c-cfea02c5e371',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TAGISSUE',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'TAGISSUE',
      description: 'TAGISSUE',
      attributeType: 'COLLECTION',
      collectionValues: ['true'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '6628bfb1-ccd3-459d-a82f-50fa13d1b4fd',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TESR_I1',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Tesr I1',
      description: 'Test',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'a2edcb1a-f4f2-4873-9ce1-0652404f54db',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TESS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'TESS',
      description: 'Tess Starr',
      attributeType: 'COLLECTION',
      collectionValues: ['TESS'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'b6aeab89-9b9d-4f5f-88d2-78f40a23120f',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Test',
      description: 'Test',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'ecbfea45-b010-4e7b-8a9c-77bfcc7866d0',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST_ANDREW',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Test Andrew',
      description: 'Test',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'e2ff218d-41b4-41e4-9713-8ddd2c84bbc0',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST_GUEST_INPUT_1',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Test Guest Input 1',
      description: 'Test Guest Input 1',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '454048fe-1fe6-41c4-b0b8-e673a62546ad',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST_REPLICA',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Test replica',
      description: 'Test replica',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '64b84376-13f8-4c0a-9f1d-b398cc3deafb',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST_REPLICA_NEW',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Test replica New',
      description: 'Test replica New',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'f2ea7d29-8063-4d33-a23b-80fa0abbc800',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Test Tag',
      description: 'Test Tag',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '0e623ce6-583d-4b94-96cc-d8bdf5cdc74b',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEST120',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'TEST120',
      description: 'TEST120',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE', 'FALSE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '9db77e4a-d8c7-4c76-a219-548a621c4861',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TESTONLY',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'TestOnly',
      description: 'TestOnly',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'ba3a1f22-b077-459a-b667-8a558a937d31',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TETS_2',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Tets 2',
      description: 'Tets 2',
      attributeType: 'NUMBER',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'af7e7a25-5491-416d-879d-1b8b2ce7c260',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TEXT_CUSTOMER_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'Text Customer tag',
      description: 'text tag',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: 'ee828e72-c80c-48fa-9353-828997372d34',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'THARUNI_TAG',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'THARUNI TAG',
      description: 'THARUNI TAG',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d8986e6-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'TIME',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Time of Day',
      description:
        'Use this to only allow Redemption of a Communication during a certain time. Most commonly used for a Happy Hour discount.',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 15,
      visibility: [
        'message.activity.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '7dbdf581-1fc6-440a-a213-1504e0383a23',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TOS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'TOS',
      description: 'TOS',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '5d898353-7358-11ec-a4a3-0aaf30814329',
      clientId: '*',
      key: 'TRANSACTION_COMPLETE',
      tagType: 'SYSTEM',
      category: 'SPEND',
      categoryDisplayTitle: 'Spend',
      categoryDisplayRank: 1,
      title: 'Transaction Complete',
      description: 'Guests that complete a transaction. ',
      attributeType: 'COLLECTION',
      collectionValues: [],
      source: 'SYSTEM',
      sourceDisplayTitle: 'System',
      tagRank: 6,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '23036b1e-090c-4d14-abdd-c2475585319e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'TTS',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'TTS',
      description: 'TTS',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'GUEST_INPUT',
      sourceDisplayTitle: 'Guest Input',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '586bf239-acf9-4427-8906-966157323636',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'USERDOMAIN',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'USERDOMAIN',
      description: 'USERDOMAIN',
      attributeType: 'COLLECTION',
      collectionValues: ['TRUE'],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
    {
      id: '8747f61d-1ae5-41fe-bd6b-70ccec2ab487',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      key: 'USER_AFFILIATION',
      tagType: 'CUSTOM',
      category: 'CUSTOM',
      categoryDisplayTitle: 'Custom',
      categoryDisplayRank: 3,
      title: 'USER_AFFILIATION',
      description: 'USER_AFFILIATION',
      attributeType: 'TEXT',
      collectionValues: [],
      source: 'IMPORTED_MANUAL',
      sourceDisplayTitle: 'Imported / Manual',
      tagRank: null,
      visibility: [
        'segment.targeting',
        'message.auto.targeting',
        'message.activity.targeting',
        'offer.auto.targeting',
        'offer.activity.targeting',
        'offer.redemption',
        'loyalty.auto.targeting',
        'loyalty.activity.targeting',
        'loyalty.redemption',
      ],
    },
  ],
  paging: {
    total: 156,
    count: 156,
    totalPages: 1,
    currentPage: 1,
  },
};
